// action

// mutations
export const SET_SHOW_MENU_ID = "SET_SHOW_MENU_ID";
export const SET_CURRENT_MODULE = "SET_CURRENT_MODULE";

// getters
export const GET_SHOW_MENU_ID = "GET_SHOW_MENU_ID";
export const GET_CURRENT_MODULE = "GET_CURRENT_MODULE";
